<template>
    <div>
        <PropHeader :title="getSettingTitle()"></PropHeader>

        <div v-if="propValid">
            <GlobalProp v-if="prop.type == 'global'" :obj="prop.component" />

            <!--底部TabBar-->
            <BottomTabBarProp v-if="prop.type == 'bottomtab'" :bottom-tab="prop.component" />
            <!--导航栏-->
            <NavigationBarProp v-else-if="prop.type == 'navigationbar'" :bottom-tab="prop.component" />

            <BannerProp v-else-if="prop.type == 'banner'" :obj="prop" />
            <WordBannerProp v-else-if="prop.type == 'word_banner'" :obj="prop" />
            <SearchBarProp v-else-if="prop.type == 'searchbar'" :obj="prop" />
            <WallpaperListProp v-else-if="prop.type == 'wallpaper_list'" :obj="prop.component" />
            <TitleBarProp v-else-if="prop.type == 'titlebar'" :obj="prop.component" />
            <MineProp v-else-if="prop.type == 'mine'" :obj="prop.component" />

            <PhotoClassifyProp v-else-if="prop.type == 'photo_classify'" :obj="prop" />
            <PhotoClassifyPlatProp v-else-if="prop.type == 'photo_classify_plat'" :obj="prop" />
            <PhotoClassifyLineProp v-else-if="prop.type == 'photo_classify_line'" :obj="prop" />
            <PhotoClassifyLineTinyProp v-else-if="prop.type == 'photo_classify_line_tiny'" :obj="prop" />
            <PhotoClassifyLineLittleProp v-else-if="prop.type == 'photo_classify_line_little'" :obj="prop" />
            <TagPhotosProp v-else-if="prop.type == 'tag_photos'" :obj="prop" />
            <BottomListWallpaperProp v-else-if="prop.type == 'bottom_list_wallpaper'" :obj="prop" />
            <BottomListAvatarProp v-else-if="prop.type == 'bottom_list_avatar'" :obj="prop" />
            <BottomListEmojiProp v-else-if="prop.type == 'bottom_list_emoji'" :obj="prop" />
            <BottomListThemeProp v-else-if="prop.type == 'bottom_list_theme'" :obj="prop" />
            <BottomListPhotoTagsProp v-else-if="prop.type == 'bottom_list_phototags'" :obj="prop" />
            <BottomListTagsAndPhotosProp v-else-if="prop.type == 'bottom_list_tagsandphotos'" :obj="prop" />

            <div v-else style="height: 100px"></div>
        </div>
    </div>


</template>

<script>
import emitter from '@/utils/eventbus';

import PropHeader from '@/components/PropHeader.vue';
import BottomTabBarProp from '@/views/Decoration/DecorationGroup/BottomTabBar/BottomTabBarProp.vue';
import NavigationBarProp from '@/views/Decoration/DecorationGroup/NavigationBar/NavigationBarProp.vue'

import GlobalProp from './DecorationGroup/Global/GlobalProp.vue';

import BannerProp from '@/views/Decoration/DecorationGroup/Banner/BannerProp.vue';
import WordBannerProp from '@/views/Decoration/DecorationGroup/WordBanner/WordBannerProp.vue';
import SearchBarProp from '@/views/Decoration/DecorationGroup/SearchBar/SearchBarProp.vue'
import WallpaperListProp from '@/views/Decoration/DecorationGroup/WallpaperList/WallpaperListProp.vue';
import TitleBarProp from '@/views/Decoration/DecorationGroup/TitleBar/TitleBarProp.vue';
import MineProp from '@/views/Decoration/DecorationGroup/Mine/MineProp.vue';

import PhotoClassifyProp from '@/views/Decoration/DecorationGroup/PhotoClassify/PhotoClassifyProp.vue';
import PhotoClassifyPlatProp from '@/views/Decoration/DecorationGroup/PhotoClassifyPlat/PhotoClassifyPlatProp.vue';
import PhotoClassifyLineProp from '@/views/Decoration/DecorationGroup/PhotoClassifyLine/PhotoClassifyLineProp.vue';
import PhotoClassifyLineTinyProp from '@/views/Decoration/DecorationGroup/PhotoClassifyLineTiny/PhotoClassifyLineTinyProp.vue';
import PhotoClassifyLineLittleProp from '@/views/Decoration/DecorationGroup/PhotoClassifyLineLittle/PhotoClassifyLineLittleProp.vue';
import TagPhotosProp from '@/views/Decoration/DecorationGroup/TagPhotos/TagPhotosProp.vue';
// import { reactive } from 'vue';
import BottomListWallpaperProp from './DecorationGroup/BottomListWallpaper/BottomListWallpaperProp.vue';
import BottomListAvatarProp from './DecorationGroup/BottomListAvatar/BottomListAvatarProp.vue';
import BottomListEmojiProp from '@/views/Decoration/DecorationGroup/BottomListEmoji/BottomListEmojiProp'
import BottomListThemeProp from '@/views/Decoration/DecorationGroup/BottomListTheme/BottomListThemeProp'
import BottomListPhotoTagsProp from './DecorationGroup/BottomListPhotoTags/BottomListPhotoTagsProp.vue';
import BottomListTagsAndPhotosProp from '@/views/Decoration/DecorationGroup/BottomListTagsAndPhotos/BottomListTagsAndPhotosProp'

export default {
    name: "DecorationProp",
    components: {
        PropHeader,
        GlobalProp,
        BottomTabBarProp,
        BannerProp,
        WordBannerProp,
        NavigationBarProp,
        SearchBarProp,
        WallpaperListProp,
        TitleBarProp,
        MineProp,
        PhotoClassifyProp,
        PhotoClassifyPlatProp,
        PhotoClassifyLineProp,
        PhotoClassifyLineTinyProp,
        PhotoClassifyLineLittleProp,
        TagPhotosProp,
        BottomListWallpaperProp,
        BottomListAvatarProp,
        BottomListEmojiProp,
        BottomListThemeProp,
        BottomListPhotoTagsProp,
        BottomListTagsAndPhotosProp
    },
    data() {
        return {
            prop: {
                type: '',
                component: {}
            },
            propValid: false
        }
    },
    methods: {
        onComponentChange(value) {
            console.log('DecorationProp 组件变化', value)
            this.propValid = false
            setTimeout(() => {
                this.prop = value
                this.propValid = true
            }, 10)
        },
        getSettingTitle() {
            if (this.prop) {
                return this.prop.name
            }
            return '-'
        }
    },
    mounted() {
        emitter.on('onComponentChange', this.onComponentChange)
    },
    beforeUnmount() {
        emitter.off('onComponentChange')
    }
}
</script>

<style scoped lang="less">

</style>

<style>
.prop-box {
    padding: 15px;
}
</style>